import { useEffect, useState } from "react";
import styled from "styled-components";

import InputText from "../shared/input/new/InputText";
import InputPassword from "../shared/input/new/InputPassword";

const Container = styled.div`
  width: 100%;
  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      display: flex;
      flex-direction: column;
      gap: 20px;
      .title{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-lg);
        color: ${({ theme }) => theme.mainTextColor};
      }
      .inputs{
        display: flex;
        flex-direction: column;
        gap: 15px;
      }
      .info{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: ${({ theme }) => theme.mainTextColor};
        display: flex;
        flex-direction: column;
        gap: 5px;
        a{
          color: var(--color-main);
        }
      }
    }
  }
`;

const UetdsYukBildirimiUserControlPage = () => {
    const [data, setData] = useState({
        user: "",
        password: ""
    });

    const [isShow, setIsShow] = useState(false);
  
    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    }

    const showPassword = () => {
        setIsShow(!isShow);
    }

  return (
    <Container>
      <div className="wrapper">
        <div className="content">
            <div className="title">Ulaştırma Bakanlığı U-ETDS Yük Bildirimi Kayıt Verileri</div>
            <div className="inputs">
                <InputText data={data.user} setData={(e) => handleChange(e)} inputWidth={"300px"} name={"data"} labelText="Gerçek Servis Kullanıcı" /> 
                <InputPassword data={data.password} setData={(e) => handleChange(e)} inputWidth={"300px"} name={"password"} labelText="Gerçek Servis Şifresi" auto={"new-password"} isShow={isShow} type={isShow ? "text" : "password"} showPassword={showPassword} />
            </div>
            <div className="info">
                <p>Araçların kayıtlı olduğu kişiye ait e-devletten Ulaştırma Bakanlığı Sistemine Veri Gönderilebilmesi için IP tanımlaması yapılması gerekmektedir.</p>
                <p>Bu IP Tanımlası işleminin nasıl yapıldığını aşağıdaki videoyu izleyerek yapabilirsiniz.</p>
                <p>IP Tanımlaması sonrasında orada oluşan Gerçek Servis Kullanıcı ve Gerçek Servis Şifresi bilgilerini yukarıya kaydediniz.</p>
                <p>Video Linki : <a target="_blank" href='https://youtu.be/83u47uAhdhE?si=bA7u41ezVbTiWCgM'>Tıklayınız</a></p>
            </div>
        </div>
      </div>
    </Container>
  );
};

export default UetdsYukBildirimiUserControlPage;
